import React from 'react'

const TechnologyHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow-tech">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <rect x="6" y="8" width="20" height="16" rx="2" stroke="#ffffff" strokeWidth="2" filter="url(#white-glow-tech)"/>
      
      <rect x="12" y="13" width="8" height="6" rx="1" fill="#ffffff" opacity="0.8"/>
      
      <path d="M12 16H8M20 16H24" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 13V10M16 19V22" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"/>
      
      <circle cx="8" cy="16" r="1.5" fill="#ffffff"/>
      <circle cx="24" cy="16" r="1.5" fill="#ffffff"/>
      <circle cx="16" cy="10" r="1.5" fill="#ffffff"/>
      <circle cx="16" cy="22" r="1.5" fill="#ffffff"/>
      
      <rect x="8" y="11" width="2" height="2" rx="0.5" fill="#ffffff" opacity="0.6"/>
      <rect x="22" y="11" width="2" height="2" rx="0.5" fill="#ffffff" opacity="0.6"/>
      <rect x="8" y="19" width="2" height="2" rx="0.5" fill="#ffffff" opacity="0.6"/>
      <rect x="22" y="19" width="2" height="2" rx="0.5" fill="#ffffff" opacity="0.6"/>
      
      <path d="M2 12C3 10 5 8 8 8" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      <path d="M30 12C29 10 27 8 24 8" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      
      <circle cx="3" cy="16" r="0.8" fill="#ffffff" opacity="0.5"/>
      <circle cx="29" cy="16" r="0.8" fill="#ffffff" opacity="0.5"/>
    </svg>
  )
}

export default TechnologyHeaderIconWhite
